'use client';

import React from 'react';
import { useParams } from 'next/navigation';

import { PageLoader } from '@shaojiang/components/site/PageLoader';
import { getCopy } from '@shaojiang/content';
import { resolveLocale } from '@shaojiang/types/i18n';

export default function Loading() {
  const params = useParams<{ lang: string }>();
  return <PageLoader copy={getCopy(resolveLocale(params?.lang)).loading} />;
}
